import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/free-solid-svg-icons'
import { useLogout } from '../../../services/auth-services/useLogout'

export default function AccessDenied () {
    return (
        <div className='flex flex-col gap-5 justify-center items-center h-screen w-full text-gray-600 bg-gray-200'>
            <div className='flex gap-2 justify-center items-center text-4xl'>
                <FontAwesomeIcon icon={faLock} />
                 <p>You don't have permission to access this page.</p>
            </div>
            <div>
                <button type="button" onClick={useLogout()} className='underline text-blue-600'>
                    Logout
                </button>
            </div>
        </div>
    )
}